import $store from '@/store/store'
import { EventBus, EventBusType } from '@/event-bus'
import { actionTypes } from '@/store/actionTypes'
import $filters from '@/filters/filters'
import ProjectService from '@/services/project.service'
import router from '@/router/router'
import moment from 'moment'

const AppService = {
    selectProjectPromise: null,
    createProjectPromise: null,
    confirmPromise: null,
    createApiKeyPromise: null,
    loading (show = true) {
        $store.dispatch(actionTypes.LOADING, show)
    },
    showLoading () {
        $store.dispatch(actionTypes.LOADING, true)
    },
    hideLoading () {
        $store.dispatch(actionTypes.LOADING, false)
    },
    inform (message, options) {
        EventBus.$emit(EventBusType.INFORM, { message, options })
    },
    closeInform () {
        EventBus.$emit(EventBusType.CLOSE_INFORM)
    },
    toast (message, type) {
        EventBus.$emit(EventBusType.TOAST, {
            group: 'app',
            title: '',
            text: message,
            duration: 3000,
            type: type
        })
    },
    toastSuccess (message) {
        this.toast(message, 'success')
    },
    toastError (message) {
        this.toast(message, 'error')
    },
    toastInfo (message) {
        this.toast(message, 'info')
    },
    createProject () {
        EventBus.$emit(EventBusType.CREATE_PROJECT)
        return new Promise((resolve, reject) => {
            this.createProjectPromise = { resolve, reject }
        })
    },
    selectProject () {
        EventBus.$emit(EventBusType.SELECT_PROJECT)
        return new Promise((resolve, reject) => {
            this.selectProjectPromise = { resolve, reject }
        })
    },
    confirm (message) {
        EventBus.$emit(EventBusType.CONFIRM, message)
        return new Promise((resolve, reject) => {
            this.confirmPromise = { resolve, reject }
        })
    },
    handleRequestError (alternateErrorMessage, hideLoading = false) {
        return error => {
            console.log(error)
            if (hideLoading) {
                this.hideLoading()
            }
            if (error.response && error.response.data) {
                let data = error.response.data
                let errorMessage = ''
                if (Array.isArray(data)) {
                    errorMessage = data.join('')
                } else if (typeof data === 'object') {
                    if (data.message) {
                        errorMessage = data.message
                    }
                }
                this.toastError(errorMessage)
            } else if (alternateErrorMessage) {
                this.toastError(alternateErrorMessage)
            } else {
                this.toastError(this.$t('error'))
            }
        }
    },
    mapPagination (pagination) {
        let str = 'page=' + pagination.page
        str += '&page_size=' + pagination.rowsPerPage
        if (pagination.sortBy) {
            let orderDirection = pagination.descending ? '-' : ''
            str += '&ordering=' + orderDirection + pagination.sortBy
        }
        return str
    },
    buildQuery (params, addQuestionMark = true) {
        let query = ''
        for (let i in params) {
            if (params[i]) {
                if (i === 'start_date') {
                    let startDate = moment.utc(moment(`${params[i]} 00:00:00`)).format('YYYY-MM-DD HH:mm:ss')
                    // eslint-disable-next-line camelcase
                    query += `&${i}=${startDate}`
                } else if (i === 'end_date') {
                    let endDate = moment.utc(moment(`${params[i]} 23:59:59`)).format('YYYY-MM-DD HH:mm:ss')
                    query += `&${i}=${endDate}`
                } else {
                    query += `&${i}=${params[i]}`
                }
            } else {
                query += `&${i}=`
            }
        }
        if (addQuestionMark) {
            return '?' + query.substring(1)
        }
        return query.substring(1)
    },
    correctHeaders (headers) {
        for (let header of headers) {
            header.text = $filters.capitalize(header.text)
            header.sortable = header.sortable | false
        }
        return headers
    },
    loadThenSelectProject (gotoSelectedProject = false) {
        ProjectService.getProjects().then(
            result => {
                let projectList = result.data
                $store.commit(actionTypes.user.PROJECTS, projectList)
                let localActiveProjectId = null
                let urlProjectId = window.vueapp.$route.params.campaignId
                if (urlProjectId) {
                    localActiveProjectId = urlProjectId
                } else {
                    localActiveProjectId = ProjectService.getLocalActiveProjectId()
                }
                let foundActiveProject = false
                if (localActiveProjectId) {
                    for (let project of projectList) {
                        if ('' + project.id === localActiveProjectId) {
                            $store.commit(actionTypes.user.ACTIVE_PROJECT, project)
                            foundActiveProject = true
                            break
                        }
                    }
                }
                if (foundActiveProject) {
                    if (gotoSelectedProject) {
                        router.push('/campaign/' + localActiveProjectId + '/bot/overview')
                    }
                } else {
                    if (projectList.length === 1) {
                        $store.commit(actionTypes.user.ACTIVE_PROJECT, projectList[0])
                        if (gotoSelectedProject) {
                            router.push(`/campaign/${projectList[0].id}/bot/overview/`)
                        }
                    } else {
                        this.selectProject().then(
                            project => {
                                $store.commit(actionTypes.user.ACTIVE_PROJECT, project)
                                if (gotoSelectedProject) {
                                    router.push(`/campaign/${project.id}/bot/overview/`)
                                }
                            }
                        )
                    }
                }
            },
            this.handleRequestError(window.vueapp.$t('canNotLoad', { item: window.vueapp.$t('campaign') }))
        )
    }
}

EventBus.$on(EventBusType.CREATE_PROJECT_DONE, data => {
    if (AppService.createProjectPromise) {
        AppService.createProjectPromise.resolve(data)
    }
})

EventBus.$on(EventBusType.SELECT_PROJECT_DONE, data => {
    if (AppService.selectProjectPromise) {
        AppService.selectProjectPromise.resolve(data)
    }
})

EventBus.$on(EventBusType.CONFIRM_DONE, data => {
    if (AppService.confirmPromise) {
        AppService.confirmPromise.resolve(data)
    }
})

export default AppService
